export const STORAGE_KEY_NAME = 'invisible/crm'